import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Table, TableColumn } from 'element-ui';

export default {
    name: 'RaceTableLayout',
    props: {
        data: Array,
        isProcessing: Boolean,
        from: Number,
        to: Number,
        total: Number,
        page: Number,
        perPage: Number,
        currentRaceId: Number
    },
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            isRowClick: true,
            isSwitherExportOne: true
        }
    },
    computed: {
    },
    methods: {
        init() {
            this.load();
        },
        load() {

        },
        rowClick(data) {
            this.$parent.filterRaceId = data.id;
            const element = event.srcElement;
            const isFirstElement = !element.lastChild.previousSibling;
            if (isFirstElement) {
                this.$emit("update:currentRaceId", data.id);
            }
        },
        exportRace(id) {
            this.$parent.filterRaceId = id;
            this.$parent.switchReport(this.isSwitherExportOne);
        }
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/races/table/table.js